// extracted by mini-css-extract-plugin
module.exports = {"circleCanvas":"Shape_circleCanvas__3SleZ","circle":"Shape_circle__3eg-c"};